import React, { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
import { addDataLayerEntry, addEventEntry } from '@printdeal/data-layer-manager';
import { navigate } from 'gatsby';
import { ErrorManagement } from '@printdeal/error-management/react';
import useGetInvoicePaymentLinkQuery from '../../../hooks/invoices/useGetInvoicePaymentLinkQuery';

interface Props {
  invoiceNumber: string;
}

const InvoicePaymentButton = ({ invoiceNumber }: Props) => {
  const intl = useIntl();

  const [queryEnabled, setQueryEnabled] = React.useState<boolean>(false);

  const getInvoicePaymentLinkQuery = useGetInvoicePaymentLinkQuery({
    invoiceNumber,
    locale: intl.locale,
    enabled: queryEnabled,
  });

  useEffect(() => {
    if (getInvoicePaymentLinkQuery.status === 'error') {
      ErrorManagement.exception({
        exception: getInvoicePaymentLinkQuery.error,
        tags: {
          fileLocation: 'InvoicePaymentButton.tsx',
          featureFunction: 'getInvoicePaymentLink',
        },
        fingerprint: ['invoice-payment-button'],
      });
    }
  }, [getInvoicePaymentLinkQuery.status]);

  useEffect(() => {
    if (getInvoicePaymentLinkQuery.data) {
      navigate(getInvoicePaymentLinkQuery.data);
    }
  }, [getInvoicePaymentLinkQuery.data]);

  return (
    <LinkAsButton
      variant="secondary"
      iconBefore="euro-sign"
      isLoading={getInvoicePaymentLinkQuery.isLoading}
      onClick={() => {
        // GA3
        addEventEntry({
          eventCategory: 'invoice_overview',
          eventAction: 'invoice_payment_button',
        });
        // GA4
        addDataLayerEntry('invoice_overview', {
          action: 'invoice_payment_button',
        });

        setQueryEnabled(true);
      }}
      className="pd-text-sm"
    >
      <FormattedMessage id="account.invoices.list.pay" defaultMessage="Pay" />
    </LinkAsButton>
  );
};

export default InvoicePaymentButton;
